import packsService from '../../../../../services/packs/packs.service'
import useHttpLoader from '../../../../../hooks/useHttpLoader'
import { useRecoilState } from 'recoil'
import sandboxAtom from '../../../../Sandbox/sandbox.atom'
import Modal from '../../../../../shared/Modal'
import Button from '../../../../../shared/Buttons/Button'
import LevelDropdown from '../../LevelNavigation/components/LevelDropdown'
import { useState } from 'react'

interface IProps {
  onClose: () => void
}

const CreateRocketModal = (props: IProps) => {
  const [sandboxState, setSandboxState] = useRecoilState(sandboxAtom)
  const [level, setLevel] = useState<string>(null)

  const { wait, loading } = useHttpLoader()
  const handleCreateRocket = () => {
    wait(packsService.createRocket(sandboxState.version.id, level), (resp) => {
      setSandboxState((prev) => {
        return {
          ...prev,
          sets: [...prev.sets, ...resp.sets],
          groups: [...prev.groups, ...resp.groups],
          tasks: [...prev.tasks, ...resp.tasks],
        }
      })
      props.onClose()
    })
  }

  return (
    <Modal onClose={props.onClose}>
      <div className="flex-form">
        <h2 style={{ marginBottom: '1em', fontSize: 28 }}>Создание сета</h2>
        <LevelDropdown level={level} onChange={setLevel} name="level" />
      </div>
      <div className="form-footer">
        <Button onClick={handleCreateRocket} loading={loading}>
          Сохранить
        </Button>
        <Button onClick={props.onClose}>Отмена</Button>
      </div>
    </Modal>
  )
}

export default CreateRocketModal
